import { Indicator } from '../../../Common/Charts/Indicator';
import { useCurrentPregnancyChartsDataContext } from './hooks/useCurrentPregnancyChartsDataContext';

export const MothersLessThan7ConsutationsPrenatal = () => {
    const { chartData } = useCurrentPregnancyChartsDataContext();

    return (
        <Indicator
            title={'Mães com menos de 7 consultas no Pré-Natal'}
            indicatorValue={chartData?.indicators?.mothersLessThan7ConsutationsPrenatal}
            className='aligned-container'
            height={350}
        />
    );
};
